// ContactForInquiry.js
import React from 'react';
import '../styles/ContactForInquiry.css';

const ContactForInquiry = () => {
  return (
    <section className="contact-for-inquiry">
      <h2>Contact for Inquiry</h2>
      <p>Details on how potential clients can reach out.</p>
    </section>
  );
};

export default ContactForInquiry;
